import { Form, Input, Row, Col, Switch, Select, DatePicker, InputNumber } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import GiftCardSelect from './customize/GiftCardSelect';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';
import systematic from '../../../config/systematic';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const EditComponent = (props: any) => {
    const apiId = 'membershipMarketingPlans';
    const [form] = Form.useForm();
    const { editMode, defaultService } = props;
    const ref = useRef<any>(undefined);
    const [membershipTypeData, setMembershipTypeData] = useState<any>();
    const [membershipMarketingPlansModelData, setMembershipMarketingPlansModelData] = useState<any>();
    const [permanentUseDisabled, setPermanentUseDisabled] = useState<boolean>(false);
    const [consumptionDisabled, setConsumptionDisabled] = useState<boolean>(false);
    const [giftCardPlansData, setGiftCardPlansData] = useState<any>();
    const [membershipPointsPlansData, setMembershipPointsPlansData] = useState<any>();
    const [id, setId] = useState<string>();

    useEffect(() => {
        ref?.current?.getRow?.then(async (res: any) => {
            if (res?.success === true) {
                const { id, isPermanentUse,
                    rewardGiftCardIds, membershipMarketingPlansModelId } = res.data;
                setPermanentUseDisabled(isPermanentUse);
                setId(id);
                form.setFieldsValue({
                    rewardGiftCardIds
                })
                setConsumptionDisabled(membershipMarketingPlansModelId === 'consumeGift' ? false : true);
            }
        })

        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'membershipMarketingPlansModel',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { membershipMarketingPlansModel } = res.data;
                    setMembershipMarketingPlansModelData(membershipMarketingPlansModel);;
                }
            });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'membershipType',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipTypeData(res.data);
                }
            });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'giftCardPlans',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setGiftCardPlansData(res.data);
                }
            });
        fetchApi.GET(defaultService,
            {
                query: {
                    apiId: 'membershipPointsPlans',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipPointsPlansData(res.data);
                }
            });
    }, []);

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        isEnter:false,
        serviceId: 'business',
        displayOptions: {
            width: 1100
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={12}>
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    label="ID"
                                    name="id">
                                    <Input disabled={true} />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="方案"
                                    name="planName"
                                    rules={[{ required: true, message: '方案名称!' }]}>
                                    <Input />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="模式"
                                    name="membershipMarketingPlansModelId"
                                    tooltip='营销方案模式'
                                    rules={[{ required: true, message: '请选择营销方案模式!' }]}>
                                    <Select
                                        showSearch
                                        placeholder="模式"
                                        optionFilterProp="children"
                                        onSelect={(e) => {
                                            setConsumptionDisabled(e === 'consumeGift' ? false : true);
                                        }}
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(membershipMarketingPlansModelData)}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="会员类别"
                                    name="membershipTypeId"
                                    tooltip='会员类别'>
                                    <Select
                                        showSearch
                                        placeholder="类别"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(membershipTypeData, { itemName: 'typeName', includeNull: true })}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="起始日期"
                                    name="startDate"
                                    tooltip='方案的起始日期'>
                                    <DatePicker
                                        disabled={permanentUseDisabled}
                                        format="YYYY-MM-DD HH:mm:ss" />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="结束日期"
                                    name="endDate"
                                    tooltip='方案的结束日期'>
                                    <DatePicker
                                        disabled={permanentUseDisabled}
                                        format="YYYY-MM-DD HH:mm:ss" />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="已用"
                                    name="usedCopies"
                                    tooltip='方案已用份数'>
                                    <InputNumber
                                        disabled={editMode === 'NEW' ? true : false}
                                        style={{ width: 130 }} />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="总数"
                                    name="totalCopies"
                                    tooltip='方案的总份数' >
                                    <InputNumber
                                        disabled={permanentUseDisabled}
                                        style={{ width: 130 }} />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="赠送积分"
                                    name="membershipPointsPlansId">
                                    <Select
                                        showSearch
                                        placeholder="赠送积分方案"
                                        optionFilterProp="children"
                                        filterOption={(input, option: any) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                        {getList.general(membershipPointsPlansData,
                                            {
                                                itemName: 'planName',
                                                includeNull: true
                                            })}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="赠送礼品卡"
                                    name="rewardGiftCardIds">
                                    <GiftCardSelect
                                        dataSource={giftCardPlansData}
                                        placeholder="选择礼品卡方案"
                                    />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="满额赠送"
                                    name="giftUponFullConsumption"
                                    tooltip='消费满额赠送' >
                                    <InputNumber
                                        disabled={consumptionDisabled}
                                        style={{ width: 105 }} />
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item
                                    label="补贴额"
                                    name="subsidyAmount"
                                    tooltip='补贴额，例如消费1000才赠送，如消费1900，可以通此补贴送两次，消费900无效' >
                                    <InputNumber
                                        disabled={consumptionDisabled}
                                        style={{ width: 110 }} />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    label="赠送上限"
                                    name="bonusLimitCount"
                                    tooltip='每次赠送的上限数'
                                    initialValue={1}>
                                    <InputNumber
                                        style={{ width: 60 }} />
                                </Form.Item>
                            </Col>

                            <Col span={6}>
                                <Form.Item
                                    label="永久"
                                    name="isPermanentUse"
                                    tooltip='方案永久使用'
                                    valuePropName="checked"
                                    initialValue={false}>
                                    < Switch
                                        onChange={(e) => {
                                            setPermanentUseDisabled(e);
                                        }}
                                        checked={false}
                                        checkedChildren="是"
                                        unCheckedChildren="否" />
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item
                                    label="状态"
                                    name="isUse"
                                    valuePropName="checked"
                                    initialValue={true}>
                                    < Switch checked={true}
                                        checkedChildren="启用"
                                        unCheckedChildren="关闭" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="备注"
                                    name="remarks">
                                    < Input.TextArea autoSize={{ minRows: 2, maxRows: 10 }} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label=""
                            name="content">
                            <WangeditorV5ForAntD
                                key={id}
                                id={`${apiId}${id}`}
                                title='内容'
                                displayMode="editor"
                                defaultService={systematic.bmService}
                                style={{ height: 400 }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            )
        },
        dateOptions: {
            columnNames: ['startDate', 'endDate']
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;